// extracted by mini-css-extract-plugin
export default {"pageWrapper":"app_pageWrapper__Pl-mI","pageContent":"app_pageContent__NIloY","pageContentWrapper":"app_pageContentWrapper__lzof8"};